import React, { createContext, useState, useMemo, useContext } from 'react';
import { Modal } from 'react-bootstrap';

interface ModalProps {
  content: React.ReactNode;
}

interface ModalContextProps {
  openModal: (props: ModalProps) => void;
  closeModal: () => void;
  modalData: any;
  updateModalData: (value: any) => void;
}

const ModalContext = createContext<ModalContextProps>({
  openModal: () => {},
  closeModal: () => {},
  modalData: undefined,
  updateModalData: () => {},
});

export const useModal = () => useContext(ModalContext);

const ModalProvider = ({ children }: { children: React.ReactNode }) => {
  const [show, setShow] = useState(false);
  const [modalContent, setModalContent] = useState<React.ReactNode>(null);

  const [modalData, setModalData] = useState<any>(undefined);

  const openModal = ({ content }: ModalProps) => {
    if (!content) {
      console.warn('Modal content is required');
      return;
    }
    setModalContent(content);
    setShow(true);
  };

  const closeModal = () => {
    setShow(false);
    setModalContent(null);
    setModalData(undefined);
  };

  const updateModalData = (value: any) => setModalData(value);

  const value = useMemo(
    () => ({
      openModal,
      closeModal,
      updateModalData,
      modalData,
    }),
    [openModal, closeModal, updateModalData, modalData],
  );

  return (
    <ModalContext.Provider value={value}>
      {children}
      <Modal
        dialogClassName="global-modal-size-350"
        centered
        show={show}
        onHide={closeModal}
      >
        <Modal.Body className="d-flex flex-column justify-content-center gap-4 px-4">
          {modalContent}
        </Modal.Body>
      </Modal>
    </ModalContext.Provider>
  );
};

export default ModalProvider;
